

export function convert_grade(props) {
    const grade_list = props['grade_list']
    let grade = props['grade']

    const c = grade_list.find(x => x['Mcode'].trim() === grade)
    if(c) {
        grade = c['McodeName']
    }

    return grade
}